<template>
  <div>
    <!-- modal dialogs -->
    <change-password></change-password>
    <change-api-key></change-api-key>
    <search-catalog></search-catalog>
    <b-navbar toggleable="lg" type="dark" variant="dark">

      <b-navbar-brand>
        <img src="@/assets/pax-white.svg" height="30" alt="">
      </b-navbar-brand>
      <b-container>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">

            <b-nav-item-dropdown v-if="isLoggedIn" right>
              <!-- Using 'button-content' slot -->
              <template slot="button-content"><em>{{ username }}</em></template>
              <b-dropdown-item v-b-modal.modal-password>Change Password</b-dropdown-item>
              <b-dropdown-item v-b-modal.modal-api v-if="isAdmin">Change API Key</b-dropdown-item>
<!--            <b-dropdown-item v-b-modal.modal-search v-if="isAdmin">Search Catalog</b-dropdown-item>-->
              <b-dropdown-item @click="signout">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>
<style>
nav.navbar.navbar-dark.bg-dark {
  background-color: #e37b23 !important;

}
</style>
<script>

import ChangePassword from './ChangePassword'
import ChangeApiKey from './ChangeApiKey'
import SearchCatalog from './Search'

export default {
  components: {
    SearchCatalog,
    ChangePassword,
    ChangeApiKey
  },
  methods: {
    signout () {
      this.$store.dispatch('logout').then(
        () => this.$router.push('/login')
      )
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    username () {
      return this.$store.getters.username
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/NavBar.vue